export const AVAILABLE_LABELS_QUERY = '/labels';
export const SUPPLIER_LABELS_QUERY = '/supplier/:id/labels';
